<his-plam *ngIf="!readonly">
    <p-autoComplete *ngIf="!readonly" #content [hisDdKey]="i18nIdentifier" styleClass="autocompleteWidth100"
        [required]="isMandatory()" [field]="fieldDisplayName" [(ngModel)]="value"
        hisEagerDataSource="{{datasourceName}}?filter_validon={{currentDate}}" [forceSelection]="true"
        (ngModelChange)="onModelChange($event)">
    </p-autoComplete>
</his-plam>

<div *ngIf="readonly && value" class="layoutBlock detailPresentationListItem">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{ i18nIdentifier | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{getFieldValue(value)}}</span>
    </div>
</div>
